import { html } from 'lit';
import type { TefComs4p } from '@src/components/TefComs4p.js';

// This is just for testing
export const forTesting = function render(this: TefComs4p) {
  return html`<p>${this.loadedResourcesCount}</p>`;
};
